import React from 'react';
import { Card } from '../../../components/ui/card';
import { KpiTimeChart } from './KpiTimeChart';
import { CHART_COLORS, fmtNum, fmtNumShort } from './kpiUtils';
import { CANAL_COLORES } from './atencionUtils';

const color = (c, i) => CANAL_COLORES[c] || CHART_COLORS[i % CHART_COLORS.length];

// B7: tickets por semana (lunes a domingo) apilados por canal, y total por canal.
export const AtencionSemanal = ({ semanal = {} }) => {
  const canales = semanal.canales || [];
  return (
    <div className="mb-6 grid grid-cols-1 gap-6 lg:grid-cols-3" data-testid="atencion-semanal">
      <Card className="p-5 lg:col-span-2 lg:p-6">
        <h2 className="mb-4 text-base font-semibold text-slate-800">Tickets por semana y canal</h2>
        <KpiTimeChart data={semanal.semanas || []} xKey="label" type="barras" stacked
          series={canales.map((c, i) => ({ key: c, name: c, color: color(c, i) }))}
          valueFormatter={fmtNum} axisFormatter={fmtNumShort} height={300} testId="atencion-semanal-chart" />
      </Card>
      <Card className="p-5 lg:p-6">
        <h2 className="mb-4 text-base font-semibold text-slate-800">Por canal</h2>
        <div className="space-y-3">
          {(semanal.por_canal || []).map((c, i) => (
            <div key={c.canal} className="flex items-center gap-3" data-testid={`atencion-canal-${c.canal}`}>
              <span className="h-3 w-3 rounded-full" style={{ backgroundColor: color(c.canal, i) }} />
              <span className="flex-1 text-sm text-slate-700">{c.canal}</span>
              <span className="font-semibold tabular-nums">{fmtNum(c.total)}</span>
            </div>
          ))}
          {!(semanal.por_canal || []).length && <p className="text-sm text-slate-400">Sin tickets en el período.</p>}
        </div>
      </Card>
    </div>
  );
};
